import axios from 'axios';
import config from '../../config/api';

export default class Api {
    constructor(options={}){
        
        this.baseUrl = config.API_HOST;

        this.axiosInstance = axios.create({
            baseURL: this.baseUrl
        });
    }
}